import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import CacheService from '../../services/cacheService';

export default class MembershipError extends Component {

    render () {
        return (
            <div>
                <div className='col-xs-12 col-md-12 col-lg-12'>
                    <div className='info-box'>
                        <h3>No Active Memberships For This Service.</h3>
                        <p>You do not have any active memberships for this service.</p>
                        <p>We are working on online memberships purchase feature. For now, please contact your club to purchase a membership.</p>
                        <Link to={`/${CacheService.getToken().bname}/`} className='btn btn-primary' >Go To Home Screen</Link>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/appointments/membershipError.js